import Common from "../../../Common";

const MOH = class extends Common {
	browse = (companyId: id) => this.get(`/company/${companyId}/pbx/mohs`)
}

export default MOH
